export enum TimeRange {
  WEEK = 'week',
  MONTH = 'month',
  ALL_TIME = 'allTime'
}
